<template>
  <div>
    <AppTopBar></AppTopBar>
    <div class="top-logo" style="cursor: pointer" v-on:click="goBack">
      <b>mediafusion</b>
    </div>

    <div class="p-grid">
      <div class="p-col-3">
        <h3>{{ translate("header.recent.offers") }}</h3>

        <DataTable
            :selection.sync="offerSelection"
            :value="getOffers"
            class="profile-table"
            rowHover
            selectionMode="single"
        >
          <Column field="label" header="Title">
            <template #body="slotProps">
              <span
                  v-html="renderOfferStateIntl(slotProps.data.offerState)"
              ></span>
              {{ slotProps.data.label }}
            </template>
          </Column>
          <Column :header="translate('label.dealMaker')" field="dealmakerId">
            <template #body="slotProps">
              {{ getDealMakerName(slotProps.data.dealmakerId) }}
            </template>
          </Column>
          <Column field="offerDate" header="Offer Date">
            <template #body="slotProps">
              <div class="centered-left">
                {{ renderDateIntl(slotProps.data.offerDate) }}
              </div>
              <div class="centered-right">
                <Button
                    :disabled="slotProps.data.offerState !== 'CREATED'"
                    class="p-button-danger"
                    icon="pi pi-trash"
                    v-on:click="deleteOfferClick(slotProps.data)"
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>

      <div class="p-col-9">
        <div class="p-grid">
          <div class="p-col-12">
            <div class="boxTitle">
              {{
                this.offerSelection
                    ? translate("edit.offer")
                    : translate("create.offer")
              }}
            </div>
          </div>
        </div>

        <div class="p-grid nested-grid" style="margin-top: 15px">
          <div class="p-col-12 p-lg-6 p-xl-4">
            <div class="p-grid p-fluid">
              <div class="p-col-4">
                <div class="box">{{ translate("label.offerTitle") }}</div>
              </div>
              <div class="p-col-8">
                <div class="box">
                  <InputText v-model="offer.label" placeholder=""></InputText>
                </div>
              </div>

              <div class="p-col-4">
                <div class="box">{{ translate("label.offerRemark") }}</div>
              </div>
              <div class="p-col-8">
                <div class="box">
                  <Textarea v-model="offer.description" cols="20" rows="6"/>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-lg-6 p-xl-4">
            <div class="p-grid p-fluid">
              <div class="p-col-4">
                <div class="box">{{ translate("label.dealMaker") }}</div>
              </div>
              <div class="p-col-8">
                <div class="box">
                  <DropDown
                      v-model="offer.dealmakerId"
                      :options="getDealMakers"
                      optionKey="id"
                      optionLabel="user"
                      optionValue="id"
                  />
                </div>
              </div>
              <div class="p-col-4">
                <div class="box">{{ translate("label.offerDate") }}</div>
              </div>
              <div class="p-col-8">
                <Calendar
                    v-model="offer.offerDate"
                    :dateFormat="dateFormat()"
                    :manualInput="false"
                    :showIcon="false"
                />
              </div>
              <div class="p-col-4">
                <div class="box">{{ translate("label.offerPartner") }}</div>
              </div>
              <div class="p-col-8">
                <div class="box">
                  <RemoteFilterDropdown
                      v-model="offer.offerPartnerId"
                      :options="getCompanyOptions"
                      optionKey="id"
                      optionLabel="name"
                      optionValue="id"
                      :filter="true"
                      v-on:filter="doFilterOfferPartner"
                  />
                </div>
              </div>
              <div class="p-col-4">
                <div class="box">{{ translate("label.contactPerson") }}</div>
              </div>
              <div class="p-col-8">
                <div class="box">
                  <DropDown
                      v-model="offer.contactPersonId"
                      :disabled="offer.offerPartnerId == null"
                      :options="getContactList"
                      :placeholder="translate('choose.contact')"
                      optionKey="id"
                      optionValue="id"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value">
                        <span
                        >{{ slotProps.value.firstName }}
                          {{ slotProps.value.lastName }}</span
                        >
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <div>
                        <span
                        >{{ slotProps.option.firstName }}
                          {{ slotProps.option.lastName }}</span
                        >
                      </div>
                    </template>
                  </DropDown>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-xl-8">
            <div class="p-grid">
              <div class="p-col-6 p-xl-6" style="text-align: left">
                <!--                <Button-->
                <!--                  :label="translate('button.back')"-->
                <!--                  v-on:click="goBack()"-->
                <!--                ></Button>-->
                <Button
                    :disabled="editDisabled"
                    :label="translate('button.add.basket')"
                    class="p-ml-2"
                    v-on:click="addBasketToOffer(true)"
                ></Button>
              </div>
              <div class="p-col-6 p-xl-6" style="text-align: right">
                <Button
                    v-if="!cancelActive"
                    :disabled="sendDisabled"
                    :label="translate('button.send.offer')"
                    class="p-button-warning"
                    v-on:click="createOfferClick"
                ></Button>
                <Button
                    v-if="!cancelActive"
                    :disabled="editDisabled"
                    :label="
                    offerSelection
                      ? translate('button.save.offer')
                      : translate('button.create.offer')
                  "
                    class="p-ml-2 p-button-success"
                    v-on:click="saveOfferClick"
                ></Button>
                <Button
                    v-if="cancelActive"
                    :label="translate('button.cancel.offer')"
                    class="p-button-danger"
                    v-on:click="cancelOfferClick"
                ></Button>
              </div>
            </div>
          </div>
        </div>
        <DataTable
            :scrollable="true"
            :value="offer.offeredTitles"
            class="profile-table"
            dataKey="basemasterGUID"
            scroll-height="500px"
            selectionMode="single"
        >
          <Column
              :header="translate('originalTitle')">
            <template #body="slotProps">
              <div class="centered-left">
                {{ slotProps.data.production.originalTitle }}
              </div>
            </template>
          </Column>
          <Column
              :header="translate('costUnitNumber')">
            <template #body="slotProps">
              <div class="centered-left">
                {{ slotProps.data.production.productionNumber }}
              </div>
              <div class="centered-right">
                <Button
                    :disabled="editDisabled"
                    class="p-button-secondary"
                    icon="pi pi-trash"
                    v-on:click="removeTitle(slotProps.data)"
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import {mapActions, mapGetters} from "vuex";
import AppTopBar from "../layout/AppTopBar";
import TranslateService from "../services/translate.service";
import OfferService from "../services/offer.service";
import router from "../router";
import {dateFormatHelper} from "@/helpers/datehelpers";
import {renderDate, renderOfferState} from "@/components/renderer";
import RemoteFilterDropdown from "@/components/RemoteFilterDropdown";

export default {
  name: "CreateOffer",
  components: {
    RemoteFilterDropdown,
    AppTopBar: AppTopBar,
  },
  data() {
    return {
      offerSelection: null,
      offer: {},
      selectedCompany: null,
    };
  },
  computed: {
    ...mapGetters("offer", [
      "getOffers",
      "getCompanyList",
      "getContactList",
      "getChartList",
      "getDealMakers",
      "getDealMakerName",
    ]),

    sendDisabled() {
      return !this.offer.id || this.editDisabled;
    },
    editDisabled() {
      return (
          _.get(this.offer, "offerState", "") === "SUBMITTED" ||
          _.get(this.offer, "offerState", "") === "CANCELLED"
      );
    },
    cancelActive() {
      return _.get(this.offer, "offerState", "") === "SUBMITTED";
    },
    getCompanyOptions() {
      let option = [];
      if (this.selectedCompany) {
        option.push(this.selectedCompany);
      }

      if (this.getCompanyList) {
        return option.concat(this.getCompanyList.filter((r) => {
          return r.id !== (this.selectedCompany ? this.selectedCompany.id : "INVALID")
        }));
      } else {
        return option;
      }
    }
  },
  methods: {
    ...mapActions("offer", [
      "loadOffers",
      "saveOffer",
      "deleteOffer",
      "loadCompanies",
      "loadContactPersons",
      "deleteChartItem",
      "loadDealMakers",
      "clearBasket"
    ]),
    selectOffer(offer) {
      console.log("Offer: ", offer);
    },
    dateFormat: dateFormatHelper,
    renderDateIntl: renderDate,
    renderOfferStateIntl: renderOfferState,
    removeTitle(item) {
      let titles = this.offer.offeredTitles;
      _.remove(titles, function (params) {
        return params.production.id === item.production.id;
      });
      this.offer.offeredTitles = [...titles];
    },

    initNewOffer() {
      this.offerSelection = null;
      this.offer.offerDate = new Date();
      this.offer.label = "Offer from " + renderDate(this.offer.offerDate);
      this.addBasketToOffer();
    },

    routeChanged() {
      let id = this.$route.params.offerId;
      if (id === "new" || id === "") {
        this.initNewOffer();
      } else {
        for (let t of this.getOffers) {
          if (t.id === id) {
            this.offerSelection = t;
            break;
          }
        }
      }
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    addBasketToOffer(manual = false) {
      if (!_.has(this.offer, "offeredTitles")) {
        Vue.set(this.offer, "offeredTitles", []);
      }

      let count = 0;

      for (let title of this.getChartList) {
        let s = _.find(this.offer.offeredTitles, (oTitle) => {
          return oTitle.production.id === title.basemasterGUID;
        });

        if (!s) {
          let offerTitle = {
            id: null,
            production: {
              id: title.basemasterGUID,
              originalTitle: title.originalTitle,
              productionNumber: title.costUnitNumber,
            },
          };
          this.offer.offeredTitles.push(offerTitle);
          count++;
        }
      }

      this.clearBasket();

      if (manual === true) {
        this.$toast.add({
          severity: "success",
          summary: "Titles added",
          detail:
              "Added " +
              count +
              " / " +
              this.getChartList.length +
              " titles to offer",
          life: 5000,
        });
      }
    },
    saveOfferClick() {
      this.saveOffer(this.offer)
          .then((r) => {
            this.$toast.add({
              severity: "success",
              summary: "Offer Saved",
              detail: 'Offer "' + this.offer.label + '" saved successfully',
              life: 5000,
            });

            if (!_.has(this.offer, "id")) {
              this.$router.push("/offer/" + r.id);
            } else {
              this.offerSelection = _.find(this.getOffers, {id: this.offer.id});
            }
          })
          .catch(() => {
            this.$toast.add({
              severity: "error",
              summary: "Error while saving offer",
              detail: 'Offer "' + this.offer.label + '" could not be saved',
              life: 5000,
            });
          });
    },
    cancelOfferClick() {
      this.offer.offerState = "CANCELLED";
      this.saveOffer(this.offer).then((r) => {
        this.offerSelection = _.find(this.getOffers, {id: r.id});
      });
    },
    deleteOfferClick(offer) {
      this.deleteOffer(offer);
    },
    createOfferClick() {
      let offer = {
        title: this.offer.label,
        remark: this.offer.description,
        dealmakerId: this.offer.dealmakerId ? this.offer.dealmakerId : null,
        offerDate: this.offer.offerDate,
        contractPartnerId: this.offer.contractPartnerId
            ? this.offer.contractPartnerId
            : null,
        contactPersonId: this.offer.contactPersonId
            ? this.offer.contactPersonId
            : null,
        offerTitles: [],
      };

      for (let title of this.offer.offeredTitles) {
        let offerTitle = {
          id: title.production.id,
          originalTitle: title.production.originalTitle,
        };
        offer.offerTitles.push(offerTitle);
      }

      OfferService.createOffer(offer)
          .then(() => {
            this.offer.offerState = "SUBMITTED";
            this.saveOffer(this.offer);

            this.$toast.add({
              severity: "success",
              summary: "Offer Created",
              detail: 'Offer "' + this.offer.label + '" created successfully',
              life: 5000,
            });
          })
          .catch(() => {
            this.$toast.add({
              severity: "error",
              summary: "Error creating offer",
              detail: 'Offer "' + this.offer.label + '" could not be created',
              life: 5000,
            });
          });
    },
    goBack() {
      router.push("/");
      // router.back()
    },
    doFilterOfferPartner(event) {
      console.log("remote filter");
      this.loadCompanies(event.value);
      // event.preventDefault();
    }
  },
  mounted() {
    this.loadOffers();
    this.loadCompanies();
    this.loadDealMakers();

    this.routeChanged();
  },
  watch: {
    ["offer.offerPartnerId"](nv) {
      if (nv) {
        OfferService.findCompany(nv).then(r => {
          this.selectedCompany = r.data;
        })
      } else {
        this.selectedCompany = null;
      }
    },
    contractPartner() {
      this.loadContactPersons(this.contractPartner);
    },
    offerSelection() {
      if (this.offerSelection === null) {
        this.offer = {};
        this.offer.offerDate = new Date();
        this.offer.label = "Offer from " + renderDate(this.offer.offerDate);
        this.addBasketToOffer();
      } else {
        this.offer = _.cloneDeep(this.offerSelection);
        this.offer.offerDate = new Date(this.offer.offerDate);
      }
    },
    $route() {
      this.routeChanged();
    },
  },
};
</script>

<style scoped>
.box {
  text-align: left;
  font-size: large;
  font-family: "Roboto", "Helvetica Neue", sans-serif;
}

.boxTitle {
  margin-top: 10px;
  text-align: left;
  font-size: x-large;
  font-family: "Roboto", "Helvetica Neue", sans-serif;
}
</style>
